import React, { memo, forwardRef } from "react";
const SvgCapitalQ = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.23 16c0-.72-.113-1.387-.34-2a4.456 4.456 0 00-.98-1.58 4.45 4.45 0 00-1.5-1.04c-.587-.253-1.24-.38-1.96-.38-.68 0-1.32.127-1.92.38-.586.253-1.093.6-1.52 1.04-.426.44-.767.967-1.02 1.58a5.44 5.44 0 00-.36 2c0 .76.113 1.453.34 2.08.24.613.567 1.14.98 1.58.427.44.934.787 1.52 1.04.587.24 1.233.36 1.94.36.694 0 1.334-.12 1.92-.36.6-.253 1.114-.6 1.54-1.04a4.7 4.7 0 001-1.58c.24-.627.36-1.32.36-2.08zm2.74 0a6.624 6.624 0 01-.8 3.22 5.444 5.444 0 01-.8 1.14c-.293.32-.6.593-.92.82v.04h2.54c.24 0 .434.04.58.12.147.067.26.153.34.26.093.107.154.22.18.34.027.12.04.22.04.3 0 .08-.013.18-.04.3a.767.767 0 01-.18.34c-.08.107-.193.2-.34.28-.146.067-.34.1-.58.1h-7.58c-1.133 0-2.167-.16-3.1-.48a6.982 6.982 0 01-2.38-1.42 6.458 6.458 0 01-1.52-2.28c-.36-.907-.54-1.933-.54-3.08 0-1.08.187-2.06.56-2.94a6.86 6.86 0 011.6-2.3 7.124 7.124 0 012.4-1.48 8.32 8.32 0 013.02-.54c1.08 0 2.08.18 3 .54.92.347 1.713.84 2.38 1.48a6.624 6.624 0 011.58 2.3c.373.88.56 1.86.56 2.94z"
      />
    </svg>
  );
});
SvgCapitalQ.displayName = "SvgCapitalQ";
const MemoForwardRef = memo(SvgCapitalQ);
export default MemoForwardRef;
